import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { DataService } from '@shared/services';
import { LogsService } from '@shared/services/logs';
import { PlatformContextService } from '@shared/services/platform-context';
import { map, Observable, switchMap } from 'rxjs';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private readonly dataService = inject(DataService);
  private readonly platformContextService = inject(PlatformContextService);
  private readonly logs = inject(LogsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.platformContextService.isServer() || req.url.includes('/i18n/') || req.responseType !== 'json')
      return next.handle(req);
    if (req.headers.has('Authorization') && req.headers.get('Authorization')?.startsWith('Bearer '))
      return next.handle(req);
    return this.dataService.get$<string>('token').pipe(
      map((token) => token),
      switchMap((jwt) => {
        try {
          const headers = environment.API.options.headers;
          req = req.clone({
            setHeaders: {
              ...headers,
            },
          });
        } catch (e) {
          this.logs.error('RequestInterceptor', 'Error cloning request with headers:', e);
        }
        if (jwt) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${jwt}`,
            },
          });
        }
        return next.handle(req);
      })
    );
  }
}
